import { useMemo } from "react";
import Loading from "../../../modules/public/loading/loading";

function Logout() {
  useMemo(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  }, []);

  return <Loading />;
}

export default Logout;
